import {PollRobotLogin} from './PollRobotLogin.js';

export class PollAdminControl extends HTMLElement {
	constructor() {
		super();
		this.shadow = this.attachShadow({mode:`open`});
		this.shadow.addEventListener(`folder-poll-edit`, evt=>{
			let pm = evt.detail;
			this.editPoll(pm);
		});
		this.shadow.addEventListener(`pollrobot-show-folders`, evt=>{
			this.showFolder(this.folder);
		});
	}
	static PollEditStartEvent(model) {
		return new CustomEvent(`folder-poll-edit`,
		{
			bubbles: true,
			composed: true,
			detail: model,
		});
	}
	computeChannel(attr) {
		let channel = this.getAttribute(attr);
		if (!channel || ``==channel) {
			const pathParts = document.location.pathname.split(`/`);
			channel = pathParts[pathParts.length-1];
			if (``==channel && 1<pathParts.length) {
				channel=pathParts[pathParts.length-2];
			}
			if (``==channel) {
				console.error(`You MUST set a data-channel, or have a valid ending path element`);
				alert(`data-channel invalid`);
				return;
			}
		}
		return channel;
	}

	connectedCallback() {
		this.apiUrl = this.hasAttribute(`api-url`) ? this.getAttribute(`api-url`) : ``;
		this.token = this.getAttribute(`token`);

		PollRobotLogin.Login(this.apiUrl).then(
			tok=>{
				if (``!=tok) {
					this.token = tok;
					this.setAttribute(`token`, tok);
					localStorage.setItem(`pollrobot-token`, tok);
					this.folder = this.getAttribute(`folder`);
					this.channel = this.computeChannel(`channel`);
					this.showFolder(this.folder);
				} else {
					console.log(`User cancelled PollRobotLogin`);
				}
			}
		);
	}

	editPoll(pm) {
		let f = document.createElement(`pollrobot-edit`);
		f.setAttribute(`token`, this.token);
		f.setAttribute(`api-url`, this.apiUrl);
		f.setAttribute(`channel`, this.channel);
		this.shadow.innerHTML = ``;
		this.shadow.appendChild(f);	
		f.setModel(pm);	
	}
	showFolder(folder) {
		let f = document.createElement(`pollrobot-folder`);
		f.setAttribute(`token`, this.token);
		f.setAttribute(`api-url`, this.apiUrl);
		f.setAttribute(`folder`, this.folder);
		this.shadow.innerHTML = ``;
		this.shadow.appendChild(f);
	}
}

customElements.define(`pollrobot-admin`, PollAdminControl);